// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.workSummary {
    padding-top: 10px;
    /* padding-left: 20px; */
    justify-content: center;
    align-items: center;
    display: flex;
    flex-direction: column;
}

.table {
    padding-top: 20px;
    width: auto;
    padding-bottom: 20px
}

.datePicker {
    padding-top: 20px;
}

.total {
    font-weight: 1000;
}

.total_number {
    color: red;
    font-weight: 1000;
}
`, "",{"version":3,"sources":["webpack://./src/pages/WorkSummary/WorkSummary.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,wBAAwB;IACxB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX;AACJ;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,iBAAiB;AACrB","sourcesContent":[".workSummary {\n    padding-top: 10px;\n    /* padding-left: 20px; */\n    justify-content: center;\n    align-items: center;\n    display: flex;\n    flex-direction: column;\n}\n\n.table {\n    padding-top: 20px;\n    width: auto;\n    padding-bottom: 20px\n}\n\n.datePicker {\n    padding-top: 20px;\n}\n\n.total {\n    font-weight: 1000;\n}\n\n.total_number {\n    color: red;\n    font-weight: 1000;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
